/* src/app/modules/employees/tiempo/tiempo.component.css */
:host {
  --ti-brand: #e3fd64;
  --ti-brand-d: #4d7a00;
  --ti-text: #1a1d23;
  --ti-muted: #6b7280;
  --ti-border: #e5e7eb;
  --ti-surface: #ffffff;
  --ti-radius: 10px;
  --ti-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.ti-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ti-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ti-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ti-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.ti-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.ti-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--ti-text);
  line-height: 1.2;
}
.ti-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--ti-muted);
}
.ti-btn-primary {
  background-color: var(--ti-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ti-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--ti-muted) !important;
}
.ti-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.ti-loading--inline {
  padding: 32px 16px;
  flex-direction: row;
  gap: 12px;
}
.ti-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.ti-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--ti-brand);
}
.ti-loading__dots {
  display: flex;
  gap: 8px;
  align-items: center;
}
.ti-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ti-brand);
  opacity: 0.3;
  animation: ti-pulse 1.2s ease-in-out infinite;
}
.ti-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.ti-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.ti-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--ti-muted);
}
@keyframes ti-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.ti-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 72px 24px;
  text-align: center;
}
.ti-empty__art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: rgba(227, 253, 100, 0.1);
}
.ti-empty__art mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  color: var(--ti-brand);
}
.ti-empty__title {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--ti-text);
}
.ti-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--ti-muted);
  max-width: 380px;
}
.ti-filter-card {
  background: var(--ti-surface);
  border: 1px solid var(--ti-border);
  border-radius: var(--ti-radius);
  box-shadow: var(--ti-shadow);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ti-filter-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ti-text);
}
.ti-filter-card__icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--ti-brand);
}
.ti-filter-form {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.ti-filter-field {
  flex: 1;
  min-width: 220px;
}
.ti-filter-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
  flex-shrink: 0;
}
.ti-results {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ti-results__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--ti-muted);
  padding-bottom: 4px;
  border-bottom: 1px solid var(--ti-border);
}
.ti-results__icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--ti-brand);
}
.ti-results__label strong {
  color: var(--ti-text);
}
.ti-groups {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
/*# sourceMappingURL=tiempo.component.css.map */
